import { Component } from '@angular/core';
import * as moment from 'moment';
import { QRInput } from 'src/app/models/qr-input.model';

@Component({
  selector: 'app-dialog-dropout',
  templateUrl: './dialog-dropout.component.html',
  styleUrls: ['./dialog-dropout.component.scss'],
})
export class DialogDropout {
  today: string = moment().format('YYYY-MM-DD'); // Fecha actual

  inputString: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Nombre',
  };

  datepickerChange(e: any): void {
    console.log(e.target.value);
  }
}
